// populate pullout content from page content
!( () => {
	/**
	 * @param {*} e 
	 * @returns page data from clicked anchor (nav menu)
	 */
	async function getPageDataFromNavClick( e ) {
		if ( e.target.parentNode.classList.contains( 'popoutToggle' ) ) {
			e.preventDefault();
			// set const
			const anchorSlug = e.target.pathname.replace( /\//g, '' ); // remove slahes from slug
			const endpoint = `/wp-json/wp/v2/pages?slug=${anchorSlug}`;
			const data = await ( await fetch( endpoint ) ).json();
			return data;
		}
		return false;
	}

	/**
	 * Retrieves and displays page content in the pullout container
	 */
	async function populatePulloutContent( e ) {
		if ( e.target.parentNode.classList.contains( 'popoutToggle' ) ) {
			e.preventDefault();
			// open pullout drawer 
			togglePullout( 'pulloutNav_container', 'off' )
			togglePullout( 'pulloutContent_container', 'toggle' );

			const data = await getPageDataFromNavClick( e );
			if ( data ) {
				const loader = document.querySelector( '.loading' );
				const target = document.getElementById( 'pulloutContent' );
				loader.classList.add( 'faded-in' ); // reset page transition

				// insert content from data
				target.innerHTML = `
			<div class="pullout-body">
				<h2 class="pullout-title">${data[0].title.rendered}</h2>
				<div>${data[0].content.rendered}</div>
			</div>`;
				loader.classList.remove( 'faded-in' );
			}
		}
	}


	document.addEventListener( 'click', populatePulloutContent );
} )();